import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { PRProcessTable } from '@app/components/apps/PRProcess/PRProcessTable';
import { LabServicesTable } from '@app/components/apps/LabItemConfig/LabServicesTable';

const AllLabServices: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/lab-services');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/lab-services',
            breadcrumbName: 'All Lab Services',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>All Lab Services</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <LabServicesTable />
        </Col>
      </Row>
    </>
  );
};

export default AllLabServices;
